import PropTypes from 'prop-types'
import { VehicleModelModel } from '../../models/vehicle/vehicle-model-model'
import { idPropType } from '../common/id-prop-type'

const { CONNECTED_CAR_MODEL_ID, MODEL_ID, NAME, VARIANT } = VehicleModelModel

/**
 * @typedef {Object} VehicleModel
 * @property {Id} [connectedCarModelId] - The ID of the connected car model
 * @property {Id} [modelId] - The ID of the model
 * @property {string} [name] - The vehicle's model name
 * @property {string} [variant] - The vehicle's variant
 */
export const vehicleModelPropType = PropTypes.shape({
    [CONNECTED_CAR_MODEL_ID]: idPropType,
    [MODEL_ID]: idPropType,
    [NAME]: PropTypes.string,
    [VARIANT]: PropTypes.string
})
